import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import PageSEO from '../../components/SEO/PageSEO';

const CGV = () => {
      // Schéma JSON-LD pour la page mentions légales
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Conditions générales de vente - Comprendre les SES",
    "description": "Conditions générales de vente du site Comprendre les SES, informations sur l'éditeur, les produits et services proposés comme les Flashcards, les cours particuliers ou les ressources gratuites, les prix et modalités de paiement, la livraison, le droit de rétractation, les garanties, la propriété intellectuelle, la responsabilité, la protection des données personnelles et les litiges.",
    "publisher": {
      "@type": "Organization",
      "name": "Comprendre les SES",
      "logo": "https://cours-ses.fr/Logo SES.png"
    },
    "license": "https://cours-ses.fr/cgv"
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="pt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-[#323c5f] mb-8">Conditions Générales de Vente et d'Utilisation</h1>
            
            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">1. Préambule</h2>
                <p className="mb-4">
                  Les présentes Conditions Générales de Vente et d'Utilisation (ci-après "CGV/CGU") régissent les relations contractuelles entre :
                </p>
                <ul className="list-disc pl-6 mb-4">
                  <li>
                    <strong>Le Vendeur :</strong> Brandon MAESTU et Marion MOREAU, auto-entrepreneurs, dont le siège social est situé au 2 Avenue Antoine de Saint-Exupéry, Bât Les Lauriers 1, 84400 Apt, France, immatriculés sous le numéro SIRET 949 911 713 00038, ci-après dénommé "Comprendre les SES" ou "nous"
                  </li>
                  <li>
                    <strong>Le Client :</strong> toute personne physique ou morale qui achète un produit ou service sur le site https://www.cours-ses.fr, ci-après dénommé "vous"
                  </li>
                </ul>
                <p>
                  Ces CGV/CGU s'appliquent à l'ensemble des produits et services proposés sur le site www.cours-ses.fr, sans restriction ni réserve. En accédant au site et en utilisant ses services, vous acceptez de vous conformer aux présentes conditions.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">2. Produits et services</h2>
                <p className="mb-4">
                  "Comprendre les SES" propose les produits et services suivants :
                </p>
                <div className="space-y-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#323c5f] mb-2">Flashcards SES</h3>
                    <p className="text-sm">
                      Cartes de révision physique (flashcards) couvrant le programme de Sciences Économiques et Sociales pour les niveaux Seconde, Première et Terminale.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#323c5f] mb-2">Cours particuliers</h3>
                    <p className="text-sm">
                      Cours individuels en visioconférence dispensés par Brandon ou Marion, adaptés aux besoins spécifiques de chaque élève.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#323c5f] mb-2">Ressources pédagogiques gratuites</h3>
                    <p className="text-sm">
                      Fiches de révision, exercices corrigés et autres supports pédagogiques téléchargeables gratuitement.
                    </p>
                  </div>
                </div>
                <p className="mt-4">
                  Les caractéristiques essentielles des produits et services sont présentées sur le site. Les photographies et illustrations sont les plus fidèles possibles mais ne peuvent assurer une similitude parfaite avec le produit ou service proposé.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">3. Prix et modalités de paiement</h2>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2">3.1 Prix</h3>
                <p className="mb-4">
                  Les prix des produits et services sont indiqués en euros toutes taxes comprises (TTC). "Comprendre les SES" se réserve le droit de modifier ses prix à tout moment, étant entendu que les produits et services seront facturés sur la base des tarifs en vigueur au moment de la validation de la commande.
                </p>
                <p className="mb-4">
                  Pour les produits physiques, les frais de livraison sont indiqués avant la validation de la commande et sont à la charge du Client.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">3.2 Modalités de paiement</h3>
                <p className="mb-4">
                  Le paiement s'effectue en ligne par carte bancaire (Visa, MasterCard, American Express) via la plateforme sécurisée Stripe. Les données bancaires sont cryptées et ne transitent jamais en clair sur le réseau. "Comprendre les SES" n'a pas accès à ces données.
                </p>
                <p className="mb-4">
                  Pour les cours particuliers, le paiement s'effectue à la réservation du cours sur le site Wooskill.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">4. Livraison</h2>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2">4.1 Délais de livraison</h3>
                <p className="mb-4">
                  Les délais de livraison sont indiqués en jours ouvrés et sont généralement de 2 à 4 jours ouvrés pour la France métropolitaine. Ces délais sont donnés à titre indicatif et ne constituent pas des délais de rigueur.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">4.2 Modalités de livraison</h3>
                <p className="mb-4">
                  Les produits sont livrés à l'adresse indiquée par le Client lors de la commande. Le Client est tenu de vérifier l'état des produits à la livraison et de signaler toute anomalie dans un délai de 48 heures.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">4.3 Frais de livraison</h3>
                <p>
                  Les frais de livraison sont calculés en fonction du poids du colis et de la destination. Ils sont indiqués avant la validation de la commande et sont à la charge du Client.
                </p>
                <div className="overflow-x-auto mt-4">
                  <table className="min-w-full bg-white border border-gray-200 rounded-lg">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="py-2 px-4 border-b text-left">Zone géographique</th>
                        <th className="py-2 px-4 border-b text-left">Délai estimé</th>
                        <th className="py-2 px-4 border-b text-left">Tarif</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="py-2 px-4 border-b">France métropolitaine</td>
                        <td className="py-2 px-4 border-b">2-4 jours ouvrés</td>
                        <td className="py-2 px-4 border-b">3,99€</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">5. Droit de rétractation</h2>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2">5.1 Délai de rétractation</h3>
                <p className="mb-4">
                  Conformément à l'article L.221-18 du Code de la consommation, vous disposez d'un délai de 14 jours à compter de la réception du produit pour exercer votre droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">5.2 Modalités de rétractation</h3>
                <p className="mb-4">
                  Pour exercer votre droit de rétractation, vous devez nous notifier votre décision par une déclaration dénuée d'ambiguïté (par exemple, lettre envoyée par la poste ou courrier électronique) à l'adresse suivante : comprendrelessespro@gmail.com
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">5.3 Remboursement</h3>
                <p className="mb-4">
                  En cas de rétractation, nous vous rembourserons tous les paiements reçus de vous, y compris les frais de livraison (à l'exception des frais supplémentaires découlant du fait que vous avez choisi, le cas échéant, un mode de livraison autre que le mode moins coûteux de livraison standard proposé par nous), sans retard excessif et, en tout état de cause, au plus tard 14 jours à compter du jour où nous sommes informés de votre décision de rétractation. Le produit devra être renvoyé pour finaliser le remboursement.
                </p>
                <p>
                  Nous procéderons au remboursement en utilisant le même moyen de paiement que celui que vous aurez utilisé pour la transaction initiale.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">6. Garanties</h2>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2">6.1 Garantie légale de conformité</h3>
                <p className="mb-4">
                  Conformément aux articles L.217-4 et suivants du Code de la consommation, vous bénéficiez de la garantie légale de conformité pour les produits que nous vendons. Cette garantie vous permet d'obtenir, sans frais, la réparation ou le remplacement du produit non conforme dans un délai de deux ans à compter de la délivrance du produit.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">6.2 Garantie des vices cachés</h3>
                <p className="mb-4">
                  Conformément aux articles 1641 et suivants du Code civil, vous bénéficiez également de la garantie des vices cachés. Cette garantie vous permet d'obtenir, au choix, la résolution de la vente ou une réduction du prix de vente, si le vice était présent au moment de l'achat et qu'il rend le produit impropre à l'usage auquel il est destiné.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">6.3 Mise en œuvre des garanties</h3>
                <p>
                  Pour mettre en œuvre ces garanties, vous devez nous contacter à l'adresse suivante : comprendrelessespro@gmail.com
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">7. Cours particuliers</h2>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2">7.1 Réservation</h3>
                <p className="mb-4">
                  La réservation d'un cours particulier s'effectue en ligne sur le site wooskil.fr. Le paiement est exigé au moment de la réservation pour confirmer le créneau horaire.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">7.2 Annulation et report</h3>
                <p className="mb-4">
                  Toute annulation ou demande de report doit être effectuée au moins 24 heures avant le début du cours. Dans ce cas, le cours sera intégralement remboursé ou pourra être reporté à une date ultérieure, selon votre choix.
                </p>
                <p className="mb-4">
                  En cas d'annulation moins de 24 heures avant le début du cours, le cours sera considéré comme dû et ne pourra faire l'objet d'un remboursement, sauf cas de force majeure dûment justifié.
                </p>
                <h3 className="text-lg font-semibold text-[#323c5f] mb-2 mt-4">7.3 Déroulement des cours</h3>
                <p>
                  Les cours particuliers se déroulent en visioconférence sur la plateforme Wooskill. Un lien de connexion vous sera envoyé par email avant le début du cours. Vous devez disposer d'une connexion internet stable et d'un équipement adapté (ordinateur, tablette ou smartphone équipé d'une caméra et d'un microphone).
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">8. Propriété intellectuelle</h2>
                <p className="mb-4">
                  Tous les éléments du site www.cours-ses.fr, qu'ils soient visuels ou sonores, y compris la technologie sous-jacente, sont protégés par le droit d'auteur, des marques ou des brevets. Ils sont la propriété exclusive de "Comprendre les SES".
                </p>
                <p className="mb-4">
                  L'utilisateur qui dispose d'un site Internet personnel et qui désire placer, pour un usage personnel, sur son site un lien simple renvoyant directement à la page d'accueil du site www.cours-ses.fr, doit obligatoirement en demander l'autorisation à "Comprendre les SES".
                </p>
                <p>
                  Toute utilisation non autorisée des contenus ou informations du site constitue une violation des droits de "Comprendre les SES" et pourra faire l'objet de poursuites judiciaires.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">9. Responsabilité</h2>
                <p className="mb-4">
                  "Comprendre les SES" ne saurait être tenu pour responsable des dommages directs ou indirects qui pourraient résulter de l'accès ou de l'utilisation du site, y compris l'inaccessibilité, les pertes de données, dommages, destructions ou virus qui pourraient affecter votre équipement informatique, et/ou de la présence de virus sur son site.
                </p>
                <p className="mb-4">
                  Les produits et services proposés sont conformes à la législation française en vigueur. La responsabilité de "Comprendre les SES" ne saurait être engagée en cas de non-respect de la législation du pays où les produits sont livrés ou les services fournis.
                </p>
                <p>
                  "Comprendre les SES" ne saurait être tenu pour responsable des dommages résultant d'une mauvaise utilisation des produits ou services achetés.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">10. Protection des données personnelles</h2>
                <p className="mb-4">
                  Les informations et données vous concernant sont traitées par "Comprendre les SES" conformément à notre Politique de Confidentialité, accessible sur notre site.
                </p>
                <p>
                  Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, de portabilité et d'opposition concernant vos données personnelles. Pour exercer ces droits, veuillez nous contacter à l'adresse : comprendrelessespro@gmail.com
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">11. Médiation et règlement des litiges</h2>
                <p className="mb-4">
                  En cas de litige, vous devez vous adresser en priorité au service client de "Comprendre les SES" à l'adresse email suivante : comprendrelessespro@gmail.com
                </p>
                <p className="mb-4">
                  Conformément aux dispositions du Code de la consommation concernant le règlement amiable des litiges, vous pouvez recourir au service de médiation proposé par "Comprendre les SES". Le médiateur "droit de la consommation" ainsi proposé est MEDICYS.
                </p>
                <p>
                  Ce dispositif de médiation peut être joint par voie électronique : www.medicys.fr, ou par voie post ale : MEDICYS - Centre de médiation et règlement amiable des huissiers de justice - 73, Boulevard de Clichy, 75009 Paris.
                </p>
                <p className="mb-4 mt-4">
                  En cas d'échec de la médiation, le litige pourra être porté devant les tribunaux compétents.
                </p>
                <p>
                  Conformément au règlement européen n°524/2013, vous pouvez également utiliser la plateforme de Règlement en Ligne des Litiges (RLL) de la Commission Européenne, accessible à l'adresse : https://ec.europa.eu/consumers/odr/
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">12. Droit applicable et juridiction compétente</h2>
                <p className="mb-4">
                  Les présentes CGV/CGU sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
                <p>
                  Pour toute question relative à l'application des présentes CGV/CGU, vous pouvez nous contacter à l'adresse : comprendrelessespro@gmail.com
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#323c5f] mb-4">13. Modifications des CGV/CGU</h2>
                <p className="mb-4">
                  "Comprendre les SES" se réserve le droit de modifier les présentes CGV/CGU à tout moment. Les CGV/CGU applicables sont celles en vigueur à la date de la commande.
                </p>
                <p>
                  Les modifications apportées aux CGV/CGU seront notifiées par leur publication sur le site www.cours-ses.fr
                </p>
              </section>

              <div className="bg-green-50 p-6 rounded-lg border border-green-100 mt-8">
                <h3 className="text-lg font-semibold text-green-800 mb-2">Acceptation des CGV/CGU</h3>
                <p className="text-green-700">
                  En utilisant le site www.cours-ses.fr et en passant commande, vous reconnaissez avoir pris connaissance des présentes CGV/CGU et les accepter sans réserve. Ces conditions constituent l'intégralité de l'accord entre vous et "Comprendre les SES" concernant l'utilisation du site et l'achat de produits ou services.
                </p>
              </div>

              <p className="text-sm text-gray-500 text-right mt-8">
                Dernière mise à jour : 27 février 2025
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CGV;